"use client"

import { useEffect } from "react"
import { pushGtmEvent } from "@lib/gtm"

const trackedPageViews = new Set<string>()

export default function AtlasAnalyticsTracker() {
  useEffect(() => {
    const page = window.location.href
    if (trackedPageViews.has(page)) return

    trackedPageViews.add(page)
    pushGtmEvent("atlas_page_view", { page })
  }, [])

  return null
}
